(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/invitee.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/invitee.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.arena.logger;
const _svs$arena$pages$team = svs.arena.pages.teams.components,
  MemberPopover = _svs$arena$pages$team.MemberPopover,
  MemberPopoverItem = _svs$arena$pages$team.MemberPopoverItem;
const _svs$arena$pages$team2 = svs.arena.pages.teams.dialogs,
  showRemoveInviteError = _svs$arena$pages$team2.showRemoveInviteError,
  showInviteeReminderError = _svs$arena$pages$team2.showInviteeReminderError,
  showSendReminderNameSuccess = _svs$arena$pages$team2.showSendReminderNameSuccess,
  showSendReminderSuccess = _svs$arena$pages$team2.showSendReminderSuccess;
const _svs$arena$service$te = svs.arena.service.teamsService,
  deleteInviteeAsync = _svs$arena$service$te.deleteInviteeAsync,
  postRemindInviteeAsync = _svs$arena$service$te.postRemindInviteeAsync;
const removeInvitee = svs.arena.store.teams.actions.removeInvitee;
const Invitee = _ref => {
  let _ref$invitation = _ref.invitation,
    invitation = _ref$invitation === void 0 ? {} : _ref$invitation,
    isLeader = _ref.isLeader,
    teamId = _ref.teamId;
  const dispatch = ReactRedux.useDispatch();
  const _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    expireDate = _React$useState2[0],
    setExpireDate = _React$useState2[1];
  React.useEffect(() => {
    const expires = new Date();
    try {
      expires.setSeconds(expires.getSeconds() + (invitation === null || invitation === void 0 ? void 0 : invitation.ttl));
      setExpireDate(dateFns.format(expires, 'd MMMM', {
        locale: dateFns.locales.sv
      }));
    } catch (err) {
      logger.warn('Error wrong format on date from backend', err);
      setExpireDate(false);
    }
  }, [invitation]);
  const removeMemberInvite = async () => {
    const invitationId = invitation.invitationId;
    const _await$deleteInviteeA = await deleteInviteeAsync(teamId, invitationId),
      error = _await$deleteInviteeA.error;
    if (error) {
      showRemoveInviteError();
      return;
    }
    dispatch(removeInvitee({
      teamId,
      invitationId
    }));
  };
  const remind = async () => {
    const _await$postRemindInvi = await postRemindInviteeAsync(invitation.invitationId),
      error = _await$postRemindInvi.error;
    if (error) {
      showInviteeReminderError();
    } else if (invitation.firstName) {
      showSendReminderNameSuccess(invitation.firstName, invitation.lastName);
    } else {
      showSendReminderSuccess(invitation.email);
    }
  };
  return React.createElement("div", {
    className: "u-flex"
  }, React.createElement("div", {
    className: "u-flex-grow-1 padding-left-1 f-400"
  }, React.createElement("span", {
    className: "f-bold"
  }, invitation === null || invitation === void 0 ? void 0 : invitation.email), React.createElement("br", null), (invitation === null || invitation === void 0 ? void 0 : invitation.ttl) && expireDate && React.createElement(React.Fragment, null, "Giltig t.o.m.", ' ', expireDate)), React.createElement("div", {
    className: "padding-right-1 u-flex u-flex-align-items-center"
  }, isLeader && React.createElement(MemberPopover, null, React.createElement(MemberPopoverItem, {
    onClick: removeMemberInvite
  }, " Ta bort "), React.createElement(MemberPopoverItem, {
    onClick: remind
  }, " P\xE5minn "))));
};
svs.arena.pages.teams.components.Invitee = Invitee;

 })(window);